import styled from 'styled-components';
import LXStyledButton from './core';

const LXMiddleButton = styled(LXStyledButton)`
  height: var(--bt-md-height);
  padding: var(--bt-md-padding);
`;

export default LXMiddleButton;
